var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHelicopter = function SvgHelicopter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 339,
    viewBox: "0 0 182 339",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.32 228.5L83.7205 235.48L0.730469 200.62L17.3205 193.65L100.32 228.5Z",
    fill: "#F4AB9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.32 228.5V242.45L83.7197 249.42V235.48L100.32 228.5Z",
    fill: "#1EC2CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7205 235.48L0.730469 200.62V214.56L83.7205 249.42V235.48Z",
    fill: "#024B85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.76 223.54L164.97 230.58L81.0498 195.34L97.8398 188.29L181.76 223.54Z",
    fill: "#F4AB9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M181.76 223.54V237.63L164.97 244.68V230.58L181.76 223.54Z",
    fill: "#1EC2CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.97 230.58L81.0498 195.34V209.44L164.97 244.68V230.58Z",
    fill: "#024B85"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4297 320.4L91.9997 326.52L164.84 295.93L150.27 289.81L77.4297 320.4Z",
    fill: "#F4AB9E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4297 320.4V332.64L91.9997 338.76V326.52L77.4297 320.4Z",
    fill: "#0288C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92 326.52L164.84 295.93V308.16L92 338.76V326.52Z",
    fill: "#1EC2CC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0596 289L69.6296 295.12L142.48 264.52L127.91 258.4L55.0596 289Z",
    fill: "#F4AB9E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0596 289V301.23L69.6296 307.35V295.12L55.0596 289Z",
    fill: "#0288C4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6299 295.12L142.48 264.52V276.76L69.6299 307.35V295.12Z",
    fill: "#1EC2CC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.71 160.78C120.71 169.13 127.48 178.7 135.83 182.16C140.76 184.16 145.14 183.66 147.9 181.16C148.926 180.138 149.724 178.91 150.241 177.557C150.759 176.204 150.983 174.756 150.9 173.31C150.9 164.96 144.13 155.39 135.78 151.93C127.43 148.47 120.71 152.42 120.71 160.78Z",
    fill: "#FFB45D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.7 193C143.216 191.024 143.885 189.092 144.7 187.22C144.7 187.22 145.25 185.98 147.85 181.17L123.65 171C124.92 173.83 126.21 177 127.42 180.32C128.36 182.93 129.14 185.38 129.8 187.66L142.7 193Z",
    fill: "#FFB45D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.6 191.65L141.72 196.25C142.26 196.48 142.72 196.25 142.72 195.67V194.49C142.695 194.189 142.589 193.901 142.413 193.656C142.237 193.411 141.997 193.219 141.72 193.1L130.6 188.49C130.05 188.26 129.6 188.49 129.6 189.07V190.25C129.625 190.552 129.731 190.841 129.907 191.088C130.083 191.334 130.322 191.528 130.6 191.65Z",
    fill: "#024B85"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130.78 194.87L141.53 199.32C142.18 199.59 142.7 199.32 142.7 198.64C142.673 198.283 142.55 197.939 142.344 197.645C142.138 197.351 141.857 197.118 141.53 196.97L130.78 192.52C130.13 192.25 129.61 192.52 129.61 193.21C129.639 193.566 129.763 193.908 129.969 194.2C130.175 194.492 130.455 194.723 130.78 194.87Z",
    fill: "#024B85"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 198.54L139.81 201.54C140.36 201.76 140.81 201.54 140.81 200.96V200.59C140.786 200.287 140.68 199.996 140.504 199.747C140.328 199.499 140.088 199.303 139.81 199.18L132.5 196.18C131.95 195.96 131.5 196.18 131.5 196.76V197.14C131.525 197.442 131.631 197.731 131.807 197.978C131.983 198.224 132.223 198.418 132.5 198.54Z",
    fill: "#024B85"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137.91 174.41L139.16 174.93C139.387 175.065 139.641 175.15 139.903 175.179C140.166 175.208 140.432 175.18 140.683 175.098C140.934 175.015 141.165 174.88 141.359 174.701C141.553 174.522 141.707 174.303 141.81 174.06C142.12 173.464 142.226 172.783 142.115 172.121C142.003 171.459 141.678 170.851 141.19 170.39C140.971 170.196 140.709 170.057 140.425 169.985C140.141 169.913 139.844 169.91 139.559 169.977C139.274 170.043 139.009 170.177 138.786 170.368C138.564 170.558 138.39 170.799 138.28 171.07C138.172 171.28 138.088 171.501 138.03 171.73L138 173L137.91 174.41Z",
    stroke: "#024B85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M137.91 174.41L137.16 190.71",
    stroke: "#024B85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M137.91 174.41L135.88 173.57",
    stroke: "#024B85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M134.4 173L133.15 172.48C132.21 172.28 131.08 170.99 130.5 169.42C129.87 167.7 130.14 166.28 131.12 166.26C132.1 166.24 133.4 167.63 134.03 169.35C134.132 169.634 134.215 169.925 134.28 170.22V170.22L134.34 171.51L134.4 173Z",
    stroke: "#024B85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M135.15 189.88L134.4 172.95",
    stroke: "#024B85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M136.43 173.79L134.4 172.95",
    stroke: "#024B85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6797 101.67V151.26L66.3297 172.95V123.37L14.6797 101.67Z",
    fill: "#F3625B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3301 172.95L103.23 157.46L125.36 147.26V129.57V98.5698L66.3301 123.37V172.95Z",
    fill: "#FFB45D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M125.36 98.5699L72.0197 77.5898L14.6797 101.67L66.3297 123.37L125.36 98.5699Z",
    fill: "#F8D7D0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6201 205.28L48.6801 113.69L56.5001 111.25",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1699 200.84C39.1699 170.313 39.1866 139.783 39.2199 109.25L47.0399 106.81",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M40.21 115.32L47.4899 118.38",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40.21 123.48L47.4899 126.54",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.21 131.64L47.4899 134.69",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.21 139.79L47.4899 142.85",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.21 147.95L47.4899 151.01",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.21 156.11L47.4899 159.17",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M40.21 164.46L47.4899 167.52",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.21 172.62L47.4899 175.68",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.21 180.78L47.4899 183.83",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M40.21 188.93L47.4899 191.99",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8301 68.6299V78.0299",
    stroke: "#024B85",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4297 59.8301V69.2301",
    stroke: "#024B85",
    strokeWidth: 8.32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6104 31.3402L107.88 51.2002L140.88 16.9702L99.6104 31.3402Z",
    fill: "#F3625B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M140.891 5.0498L133.21 8.2698L128.811 21.1798L140.891 16.9698V5.0498Z",
    fill: "#F3625B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5596 75.0801V84.4801",
    stroke: "#024B85",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M100.16 66.2798V75.6798",
    stroke: "#024B85",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4297 84.4801L77.1097 85.7801L107.84 72.8701",
    stroke: "#024B85",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4297 78.3898L58.1197 79.6898L88.8497 66.7798",
    stroke: "#024B85",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M115.63 48.8402C110.211 58.7646 101.604 66.5719 91.1996 71.0002C86.0067 73.7303 80.414 75.6204 74.6296 76.6002C69.4799 77.4206 64.2439 77.5517 59.0596 76.9902C51.1396 76.3702 42.7096 75.7102 38.7896 69.5802C35.1896 63.9702 39.2996 60.1802 42.7896 54.9602C47.1996 48.4202 45.7896 47.2402 48.6796 43.7702C52.1496 39.6302 56.2696 39.0402 67.5096 36.3302C89.2596 31.0902 87.9196 29.9102 92.9596 30.1102C97.3896 30.2802 106.89 31.5102 117.82 40.5502C118.354 41.5821 118.596 42.7405 118.52 43.9002C118.417 44.8819 118.107 45.8305 117.608 46.6825C117.11 47.5344 116.435 48.2701 115.63 48.8402Z",
    fill: "#F3625B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3499 46.23C51.7099 46.23 67.51 52.56 68.5 53.97C69.49 55.38 65.72 68.97 62.93 66.07C60.14 63.17 47.27 58.22 44.93 58.25C42.59 58.28 48.9999 46.23 50.3499 46.23Z",
    fill: "#CAEDFD"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9803 52.7302C52.5989 52.7302 53.1003 52.2288 53.1003 51.6102C53.1003 50.9917 52.5989 50.4902 51.9803 50.4902C51.3618 50.4902 50.8604 50.9917 50.8604 51.6102C50.8604 52.2288 51.3618 52.7302 51.9803 52.7302Z",
    fill: "#024B85"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5599 56.9099C63.1895 56.9099 63.7 56.3995 63.7 55.7699C63.7 55.1403 63.1895 54.6299 62.5599 54.6299C61.9303 54.6299 61.4199 55.1403 61.4199 55.7699C61.4199 56.3995 61.9303 56.9099 62.5599 56.9099Z",
    fill: "#024B85"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8 55.3901C53.7042 55.8605 53.7808 56.3497 54.0158 56.7683C54.2508 57.1869 54.6285 57.507 55.08 57.6701C55.5132 57.8316 55.9859 57.8538 56.4323 57.7337C56.8786 57.6136 57.2764 57.3572 57.57 57.0001",
    stroke: "#024B85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5498 36.4898C72.8093 38.5621 75.7639 39.7118 78.8298 39.7118C81.8958 39.7118 84.8503 38.5621 87.1098 36.4898L80.9198 28.0898L78.4898 24.7798L70.5498 36.4898Z",
    fill: "#024B85"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0599 1.47996C49.9487 9.49067 62.5012 16.4695 75.5799 22.3399C92.3382 29.8509 109.87 35.5014 127.86 39.19C132.35 41.98 134.39 43.9399 134.01 45.09C133.423 46.8499 127.09 46.68 115.01 44.58C86.7042 28.4374 56.5526 15.7723 25.2099 6.85995C21.8766 4.62662 20.3899 2.95995 20.7499 1.85995C21.3366 0.0932864 27.1066 -0.0333775 38.0599 1.47996Z",
    fill: "#43AEDE"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M119.61 1.47996C107.72 9.48855 95.168 16.4672 82.0904 22.3399C65.3293 29.8525 47.7943 35.503 29.8004 39.19C25.3204 41.9833 23.2737 43.95 23.6603 45.09C24.2537 46.8499 30.587 46.68 42.6603 44.58C70.9707 28.4397 101.125 15.7748 132.47 6.85995C135.804 4.62662 137.29 2.95995 136.93 1.85995C136.31 0.0932864 130.537 -0.0333775 119.61 1.47996Z",
    fill: "#43AEDE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M135.82 22.2402L140.92 16.9502C141.92 19.6002 143.01 22.2602 144.05 24.9502L141.31 25.7602L135.82 22.2402Z",
    fill: "#F3625B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelicopter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/helicopter.c49f6eb3.svg";
export { ForwardRef as ReactComponent };